import { Moment } from 'moment';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbMomentAdapter } from './ngb-moment-adapter';
import * as _ from 'lodash';

export class DatePickerConfiguration {
  private _whitelist: NgbDateStruct[];

  minDate: Moment;
  maxDate: Moment;
  allowPriorToMinDate: boolean;
  allowAfterMaxDate: boolean;
  enforceManualEntry: boolean;
  disabledMessage: string;
  set whitelist(dates: Moment[]) {
    this._whitelist = _.map(dates, (d) => NgbMomentAdapter.fromMoment(d));
  }

  constructor(init?: Partial<DatePickerConfiguration>) {
    Object.assign(this, init);
  }

  isWhitelisted(date: NgbDateStruct): boolean {
    const ngbDate = new NgbDate(date.year, date.month, date.day);
    return this._whitelist && this._whitelist.some((d) => ngbDate.equals(d as NgbDate));
  }

  isDisabled(date: NgbDateStruct): boolean {
    const momentDate = NgbMomentAdapter.toMoment(date);
    if (momentDate < this.minDate) {
      return !this.allowPriorToMinDate;
    }
    if (momentDate > this.maxDate) {
      return !this.allowAfterMaxDate;
    }
    if (this._whitelist) {
      return !this.isWhitelisted(date);
    }
    return false;
  }
}
